import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Button.module.scss';

export const Button = ({ color, wide, shadow, float, noUppercase, ...props }) => {
    // deconstructing class name from outside and rest of props like button functionality
    const { className, ...restProps } = props;

    const buttonClass = classNames(styles.button, className, {
        [styles['button--float']]: float,
        [styles['button--wide']]: wide,
        [styles[`button--${color}`]]: color,
        [styles[`button--shadow`]]: shadow,
        [styles['button--no_uppercase']]: noUppercase
    });

    return (
        <button className={buttonClass} {...restProps}>
            {props.children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.oneOf([
        'yellow',
        'blue',
        'green',
        'red',
        'white',
        'white-outlined',
        'light-green',
        'margin-yellow',
        'dark-green',
        'dark-grey'
    ]),
    wide: PropTypes.bool,
    shadow: PropTypes.bool,
    float: PropTypes.bool,
    noUppercase: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string
};
